import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL + "/api";

const api = axios.create({
  baseURL: BASE,
  withCredentials: true,
});

// Global 401 handler - redirect to login when session expires
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Try to refresh token first
      try {
        await axios.post(`${BASE}/auth/refresh`, {}, { withCredentials: true });
        // Retry original request
        return api.request(error.config);
      } catch {
        // Refresh failed - redirect to login
        window.location.href = "/login";
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { BASE };
